
import React, { useEffect, useRef, useState } from 'react'
import { Modal as BSModal, ModalProps } from 'react-bootstrap'

import Times from '@/Components/SvgImages/Times';

import './Modal.scss'

interface Props extends ModalProps {
  show: boolean
  title?: string
  optionsButtons?: any[]
  showCloseButton?: boolean
  onClose?: () => void
  children: any
}

const Modal = (props: Props) => {

  const { show, title, onClose, showCloseButton, children, className, ...rest } = props

  const optionsButtons = props.optionsButtons || []

  return (
    <BSModal
      show={show}
      onHide={onClose}
      className={`app-modal ${className}`}
      {...rest}
    >
      <BSModal.Header>
        {title && (
          <BSModal.Title>{props.title}</BSModal.Title>
        )}
        {(optionsButtons.length > 0 || showCloseButton) && (
          <div className="modal-options-buttons">
            {optionsButtons.map((button: any, i: number) => (
              <button
                key={i}
                className="modal-options-button"
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.icon}
              </button>
            ))}
            {showCloseButton && (
              <button className="modal-options-button"
                onClick={onClose}
              >
                <Times
                  height={24}
                  width={24}
                />
              </button>
            )}
          </div>
        )}
      </BSModal.Header>
      <BSModal.Body>
        {children}
      </BSModal.Body>
    </BSModal>
  )
}

export default Modal

